// src/constants/routes.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import PrivateRoute from '../auth/components/PrivateRoute';

// Static pages
const Home = React.lazy(() => import('../pages/Home'));
const Patterns = React.lazy(() => import('../pages/Patterns'));
const Trainer = React.lazy(() => import('../pages/Trainer'));
const PatternRecognition = React.lazy(() => import('../pages/trainer/PatternRecognition'));
const ProblemRecognition = React.lazy(() => import('../pages/trainer/ProblemRecognition'));
const UnderConstruction = React.lazy(() => import('../pages/UnderConstruction'));
const NotFound = React.lazy(() => import('../pages/NotFound'));
const LearnMorePatterns = React.lazy(() => import('../pages/LearnMorePatterns'));
const LearnMoreTrainer = React.lazy(() => import('../pages/LearnMoreTrainer'));
const LearnMorePatternRecognition = React.lazy(() => import('../pages/trainer/LearnMorePatternRecognition'));
const LearnMoreProblemRecognition = React.lazy(() => import('../pages/trainer/LearnMoreProblemRecognition'));
const PrivacyPolicy = React.lazy(() => import('../pages/PrivacyPolicy'));
const TermsOfService = React.lazy(() => import('../pages/TermsOfService'));

// Creational patterns
const Singleton = React.lazy(() => import('../pages/patterns/creational/Singleton'));
const Builder = React.lazy(() => import('../pages/patterns/creational/Builder'));
const AbstractFactory = React.lazy(() => import('../pages/patterns/creational/AbstractFactory'));
const FactoryMethod = React.lazy(() => import('../pages/patterns/creational/FactoryMethod'));
const Prototype = React.lazy(() => import('../pages/patterns/creational/Prototype'));

// Structural patterns
const Adapter = React.lazy(() => import('../pages/patterns/structural/Adapter'));
const Bridge = React.lazy(() => import('../pages/patterns/structural/Bridge'));
const Composite = React.lazy(() => import('../pages/patterns/structural/Composite'));
const Decorator = React.lazy(() => import('../pages/patterns/structural/Decorator'));
const Facade = React.lazy(() => import('../pages/patterns/structural/Facade'));
const Flyweight = React.lazy(() => import('../pages/patterns/structural/Flyweight'));
const Proxy = React.lazy(() => import('../pages/patterns/structural/Proxy'));

// Behavioral patterns
const ChainOfResponsibility = React.lazy(() => import('../pages/patterns/behavioral/ChainOfResponsibility'));
const Command = React.lazy(() => import('../pages/patterns/behavioral/Command'));
const Interpreter = React.lazy(() => import('../pages/patterns/behavioral/Interpreter'));
const Iterator = React.lazy(() => import('../pages/patterns/behavioral/Iterator'));
const Mediator = React.lazy(() => import('../pages/patterns/behavioral/Mediator'));
const Memento = React.lazy(() => import('../pages/patterns/behavioral/Memento'));
const Observer = React.lazy(() => import('../pages/patterns/behavioral/Observer'));
const State = React.lazy(() => import('../pages/patterns/behavioral/State'));
const Strategy = React.lazy(() => import('../pages/patterns/behavioral/Strategy'));
const TemplateMethod = React.lazy(() => import('../pages/patterns/behavioral/TemplateMethod'));
const Visitor = React.lazy(() => import('../pages/patterns/behavioral/Visitor'));

// Auth pages
const LoginPage = React.lazy(() => import('../auth/pages/LoginPage'));
const RegisterPage = React.lazy(() => import('../auth/pages/RegisterPage'));
const ConfirmEmailPage = React.lazy(() => import('../auth/pages/ConfirmEmailPage'));
const ResendConfirmationPage = React.lazy(() => import('../auth/pages/ResendConfirmationPage'));
const ForgotPasswordPage = React.lazy(() => import('../auth/pages/ForgotPasswordPage'));
const ResetPasswordPage = React.lazy(() => import('../auth/pages/ResetPasswordPage'));

const routes = [
	{ path: "/", element: <Home /> },
	{ path: "/patterns", element: <Patterns /> },
	{ path: "/trainer", element: <PrivateRoute><Trainer /></PrivateRoute> },
	{ path: "/trainer/pattern-recognition", element: <PrivateRoute><PatternRecognition /></PrivateRoute> },
	{ path: "/trainer/problem-recognition", element: <PrivateRoute><ProblemRecognition /></PrivateRoute> },
	{ path: "/progress", element: <UnderConstruction /> },
	{ path: "/login", element: <Navigate to="/auth/login" replace /> },
	{ path: "/auth/login", element: <LoginPage /> },
	{ path: "/auth/register", element: <RegisterPage /> },
	{ path: "/auth/confirm-email", element: <ConfirmEmailPage /> },
	{ path: "/auth/resend-confirmation", element: <ResendConfirmationPage /> },
	{ path: "/auth/forgot-password", element: <ForgotPasswordPage /> },
	{ path: "/auth/reset-password", element: <ResetPasswordPage /> },
	{ path: "/learn-more-patterns", element: <LearnMorePatterns /> },
	{ path: "/learn-more-trainer", element: <LearnMoreTrainer /> },
	{ path: "/learn-more-trainer/pattern-recognition", element: <LearnMorePatternRecognition /> },
	{ path: "/learn-more-trainer/problem-recognition", element: <LearnMoreProblemRecognition /> },
	{ path: "/privacy-policy", element: <PrivacyPolicy /> },
	{ path: "/terms-of-service", element: <TermsOfService /> },
	// Creational
	{ path: "/patterns/singleton", element: <Singleton /> },
	{ path: "/patterns/builder", element: <Builder /> },
	{ path: "/patterns/abstract-factory", element: <AbstractFactory /> },
	{ path: "/patterns/factory-method", element: <FactoryMethod /> },
	{ path: "/patterns/prototype", element: <Prototype /> },
	// Structural
	{ path: "/patterns/adapter", element: <Adapter /> },
	{ path: "/patterns/bridge", element: <Bridge /> },
	{ path: "/patterns/composite", element: <Composite /> },
	{ path: "/patterns/decorator", element: <Decorator /> },
	{ path: "/patterns/facade", element: <Facade /> },
	{ path: "/patterns/flyweight", element: <Flyweight /> },
	{ path: "/patterns/proxy", element: <Proxy /> },
	// Behavioral
	{ path: "/patterns/chain-of-responsibility", element: <ChainOfResponsibility /> },
	{ path: "/patterns/command", element: <Command /> },
	{ path: "/patterns/interpreter", element: <Interpreter /> },
	{ path: "/patterns/iterator", element: <Iterator /> },
	{ path: "/patterns/mediator", element: <Mediator /> },
	{ path: "/patterns/memento", element: <Memento /> },
	{ path: "/patterns/observer", element: <Observer /> },
	{ path: "/patterns/state", element: <State /> },
	{ path: "/patterns/strategy", element: <Strategy /> },
	{ path: "/patterns/template-method", element: <TemplateMethod /> },
	{ path: "/patterns/visitor", element: <Visitor /> },
	{ path: "*", element: <NotFound /> },
];

export default routes;
